export default "__VITE_ASSET__f4068c18__"